import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import SubmitButton from './SubmitButton';

export default function SaveButton({ children, ...rest }) {
    const { t } = useTranslation('ui');

    return (
        <SubmitButton size="small" noborder btnStyle="primary" isInitialHidden {...rest}>
            {children || t('button.save')}
        </SubmitButton>
    );
}

SaveButton.propTypes = {
    children: PropTypes.any,
};

SaveButton.defaultProps = {
    children: null,
};
